export enum NotificationType {
    Success = "success",
    Info = "info",
    Warning = "warning",
    Danger = "danger",
}
